import { IMedia } from 'server/models/Product';

export const isMedia = (input?: unknown): input is IMedia =>
  typeof (input as IMedia | undefined)?.mediaType === 'string';
